import { OpenSavedFilterAreaModalContent } from 'legacy/lut/components/widgets/public/partner360/composedReport/components/filterArea/filterButtons/filterAreaModal/components/filterAreaModalContent/OpenSavedFilterAreaModalContent'
import { useCallback, useMemo } from 'react'

import { ModalDialog } from 'core-components/library/modalDialog'
import MeasureController from 'core/analytics/MeasureController'

interface IProps {
  metrics: MeasureController
  isOpen: boolean
  onCloseDialog: () => void
}

export const OpenSavedFilterAreaModal = ({ metrics, isOpen, onCloseDialog }: IProps) => {
  const onClose = useCallback(() => {
    onCloseDialog()
  }, [onCloseDialog])

  const contentProps = useMemo(() => {
    return {
      onClose: onClose,
      metrics: metrics,
    }
  }, [metrics, onClose])

  return (
    <ModalDialog
      show={isOpen}
      size={'lg'}
      onClose={onClose}
      content={OpenSavedFilterAreaModalContent}
      contentProps={contentProps}
    />
  )
}
